module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [(_vm.checkout_orders.length != 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.checkout_processed) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin": "0 1em"
    }
  }, [_c('h3', {
    staticClass: "margin-bottom"
  }, [_vm._v("Billing details")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Enter the details below to Checkout"), _c('br'), _vm._v(" "), (_vm.new_account) ? _c('span', [_vm._v("Do you have a "), _c('b', [_vm._v("Buypoint Account? ")]), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("You can use it to process your orders")])]) : _c('span', [_vm._v("Don't have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('new-account', '')
      }
    }
  }, [_vm._v("Click Here")])])])]), _vm._v(" "), _c('div', {}, [(_vm.new_account) ? _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "sp-input",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "sp-input",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "id": "Last-name-2"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "sp-input",
    attrs: {
      "type": "number",
      "placeholder": "Phone No"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.prep_process_checkout
    }
  }, [_vm._v("Process Checkout")])])])]) : _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "sp-input",
    attrs: {
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "sp-input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loginAndProcess()
      }
    }
  }, [_vm._v("Process Checkout")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px",
      "margin": "1em"
    }
  }, [_vm._v("Items to Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em"
    }
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "border": "#f7f7f7 solid",
        "margin-bottom": "1em",
        "height": "auto",
        "box-shadow": "0px 8px 16px 0px rgba(0,0,0,0.2)"
      }
    }, [_c('div', {
      staticClass: "col lg-12 md-12",
      staticStyle: {
        "margin": "1em"
      }
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding-top": "1em"
        }
      }, [_c('div', [_c('div', {
        staticStyle: {
          "width": "30%",
          "float": "left"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "60%",
          "float": "right"
        }
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('p', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v(" Qty: " + _vm._s(item.product_item_order_quantity))]), _c('br'), _vm._v(" "), _c('p', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("  ₦" + _vm._s((item.product_item_price * item.product_item_order_quantity).toFixed(2)))]), _c('br'), _vm._v(" "), (group.order_items.length > 1) ? _c('div', {
        staticClass: "col-xs-9 pull-right"
      }, [(item.calculated_product_delivery_fee > 0) ? _c('p', [_vm._v("This item's Shipping Fee: " + _vm._s(item.calculated_product_delivery_fee))]) : _vm._e()]) : _vm._e()])])])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "width": "100%",
        "border-top": "#f3f0f0 solid 1px",
        "padding-top": "1em",
        "padding-bottom": "1em"
      }
    }, [(group.total_order_coupons_amount != 0) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.total_order_coupons_amount).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(1, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.order_total_amount).toFixed(2)))])]), _vm._v(" "), (group.order_total_delivery_charge > 0) ? _c('div', [_vm._m(2, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s(group.order_total_delivery_charge))])]) : _vm._e()])], 2)])
  }))]), _vm._v(" "), _c('component-footer')], 1) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1.55em"
    }
  }, [_c('div', [_c('h5', {
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "margin": "0"
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row cktop ck-card-row"
  }, [_c('div', {
    staticClass: "mobi-on"
  }, [_c('p', [_c('b', [_c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.payment_details.payment_ref))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("₦" + _vm._s(_vm.total_orders_amount.toFixed(2)))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('p', {
    staticClass: "bar-top"
  }, [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]), _vm._v(" "), _c('p', {
    staticClass: "bar-top"
  }, [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]), _vm._v(" "), _c('p', {
    staticClass: "bar-top"
  }, [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.order_delivery_sorted_locations.cities) ? _c('div', _vm._l((_vm.order_delivery_sorted_locations.cities), function(location) {
    return _c('div', {
      staticClass: "ck-card-row-slim"
    }, [_c('label', [_vm._v("Enter Shipping Address For "), _c('b', [_vm._v(_vm._s(location.city_name))])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.address),
        expression: "location.address"
      }],
      staticClass: "form-control sp-input",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (location.address)
      },
      on: {
        "change": function($event) {
          _vm.setSortedOrderLocationAddress(location)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.address = $event.target.value
        }
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.componentOrderMainLocation
  }, [_c('div', {
    staticClass: "ck-card-row-slim"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "basis-200px"
  }, [_c('div', {
    staticClass: "w-form"
  }, [_c('form', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.state),
      expression: "order_delivery_main_location.state"
    }],
    staticClass: "sp-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_delivery_main_location.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setCities(_vm.order_delivery_main_location.state)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('div', {
    staticClass: "loading-sm"
  })]) : _vm._e()]), _vm._v(" "), (_vm.set_cities.length != 0) ? _c('div', {
    staticClass: "ck-card-row-slim"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "basis-200px"
  }, [_c('div', {
    staticClass: "w-form"
  }, [_c('form', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.city),
      expression: "order_delivery_main_location.city"
    }],
    staticClass: "sp-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_delivery_main_location.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOrderLocations(_vm.order_delivery_main_location)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.set_cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city
      }
    }, [_vm._v(_vm._s(city.city_name))])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.order_delivery_main_location.show_address_input) ? _c('div', {
    staticClass: "ck-card-row-slim"
  }, [_c('label', [_vm._v("Enter Shipping Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.address),
      expression: "order_delivery_main_location.address"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Shipping Address"
    },
    domProps: {
      "value": (_vm.order_delivery_main_location.address)
    },
    on: {
      "change": function($event) {
        _vm.setOrderLocationAddress(_vm.order_delivery_main_location)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_delivery_main_location.address = $event.target.value
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1.5em"
    }
  }, [_vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "border": "#f7f7f7 solid",
        "padding": "8px",
        "margin-bottom": "1em",
        "height": "auto",
        "box-shadow": "0px 8px 8px 0px rgba(0,0,0,0.2)"
      }
    }, [(group.order_is_business_agent && (group.order_is_business_agent == 1)) ? _c('p', [_c('b', [_vm._v(_vm._s(group.order_business_agent_name))])]) : _c('p', [_c('b', [_vm._v(_vm._s(group.order_business))])]), _vm._v(" "), ((group.order_business_agent_type && (group.order_business_agent_type == 19))) ? _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Selling for: ")]), _c('b', [_vm._v(_vm._s(group.order_business))])]) : _vm._e(), _vm._v(" "), _vm._l((group.order_items), function(item) {
      return _c('div', {
        staticClass: "row ck-card-row",
        staticStyle: {
          "clear": "both"
        }
      }, [_c('div', {}, [_c('div', {
        staticStyle: {
          "width": "30%",
          "float": "left"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_group_image && (item.product_item_group_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": item.product_item_group_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "60%",
          "float": "right"
        }
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('p', [_vm._v(" QTY: " + _vm._s(item.order_item_quantity))]), _vm._v(" "), _c('p', [(item.order_item_quantity > 1) ? _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_total_price.toFixed(2))), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(item.order_item_total) + "\r\n                                        ")])]), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
        staticStyle: {
          "clear": "both",
          "width": "100%",
          "border-top": "#f3f0f0 solid 1px",
          "padding-top": "1em"
        }
      }, [_vm._m(6, true), _vm._v(" "), ((group.order_items.length > 1)) ? _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }, [(item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
        staticStyle: {
          "color": "#ff0000",
          "float": "left"
        }
      }, [_vm._v("Product Shipping Fee:")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("₦" + _vm._s(item.order_item_delivery_fee))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
        staticStyle: {
          "color": "#ff0000",
          "float": "left"
        }
      }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(" ₦" + _vm._s(item.order_item_total_delivery_fee))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "margin-bottom": "5px",
          "display": "none"
        }
      }, [_c('span', [_c('a', {
        staticClass: "mobi-on",
        staticStyle: {
          "cursor": "pointer",
          "color": "#000000"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(index, group, item)
          }
        }
      }, [_vm._v("Remove")]), _vm._v(" "), _c('a', {
        staticClass: "mobi-off",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(index, group, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close"
      }), _vm._v("Remove")])])])]) : _vm._e()])])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
      staticClass: "c-cart-totals"
    }, [_c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1em 0"
      }
    }, [(group.order_delivery_city) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: " + _vm._s(group.order_delivery_city))]) : _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: Not set yet")]), _vm._v(" "), (group.order_user_delivery_address) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Address: " + _vm._s(group.order_user_delivery_address))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'cdl' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#cccbbb dashed 1px",
        "margin": "2em 0 2em 0"
      }
    }, [((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0))) ? _c('div', [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Shipping Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_custom), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('label', [_vm._v("OR Select State In Nigeria")]) : _c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getOrderLocations(index, group.order_delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('div', {
      staticClass: "loading-sm"
    })]) : _vm._e()]), _vm._v(" "), (group.sorted_order_business_delivery_options) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.sorted_order_business_delivery_options), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2)]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(group.order_delivery_selected_state.state_id)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.cities.length > 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.resetDeliveryLocation(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e()]), _vm._v(" "), (group.order_delivery_city) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [(group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                                " + _vm._s(address.address_address) + "\r\n                                                            ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Enter Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_user_delivery_address),
        expression: "group.order_user_delivery_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (group.order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_user_delivery_address = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])])]), _vm._v(" "), (group.order_delivery_city) ? _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "id": 'cdlb' + index
      },
      on: {
        "click": function($event) {
          _vm.setComponent('change-delivery-option', index)
        }
      }
    }, [_vm._v("Change Location")]) : _vm._e()]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "0.8em"
      }
    }, [_c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Subtotal:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_items_total.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Shipping:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_delivery_fee.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), (group.order_processing_fee_client_pay) ? _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Processing Fee:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_processing_fee.toFixed(2)))])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.total_amount.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(group.data_processing_message))]), _vm._v(" "), ((group.order_delivery_city != undefined || group.order_delivery_city != '')) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [(group.show_address_input) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [_c('label', [_vm._v("Enter Shipping Address For "), _c('b', [_vm._v(_vm._s(group.order_delivery_city))])]), _vm._v(" "), _c('label', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_user_delivery_address),
        expression: "group.order_user_delivery_address"
      }],
      staticClass: "form-control sp-input",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (group.order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_user_delivery_address = $event.target.value
        }
      }
    }), _vm._v(" "), (group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                            " + _vm._s(address.address_address) + "\r\n                                                        ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('close-enter-delivery-address', index)
        }
      }
    }, [_vm._v("Done")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    }), _vm._v(" "), _c('div', [(group.order_user_delivery_address != '' && (group.order_user_delivery_address != undefined)) ? _c('button', {
      staticClass: "pull-right btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "color": "#ffffff",
        "background": "#fc4848"
      },
      on: {
        "click": function($event) {
          _vm.setProcessPaymentSingle(group, index, 'POS' + index)
        }
      }
    }, [_vm._v("Pay")]) : _c('button', {
      staticClass: "pull-right btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "color": "#ffffff",
        "background": "#fc4848"
      },
      on: {
        "click": function($event) {
          _vm.setProcessPaymentSingle(group, index, 'POS' + index)
        }
      }
    }, [_vm._v("Make Payment")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'POS' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "clear": "both",
        "margin": "0.1em"
      }
    }, [_c('h3', [_vm._v("How would you"), _c('br'), _vm._v(" like to Pay?\r\n                                                    "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.closeViews('POS' + index)
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), (((group.business_bank_details.length != 0) || (group.business_agent_bank_details.length != 0))) ? _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0"
      },
      on: {
        "click": function($event) {
          _vm.toggleViews('BBanks' + index)
        }
      }
    }, [_vm._v("Manual Bank Transfer")]), _vm._v(" "), _c('div', {
      staticClass: "ibox",
      staticStyle: {
        "display": "none",
        "border": "1px solid #ccc",
        "padding": "1.05em"
      },
      attrs: {
        "id": 'BBanks' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(group.total_amount.toFixed(2)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Ref: ")]), _vm._v(_vm._s(group.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Pay to:")]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-xs btn-default",
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _c('span', [_vm._v("Confirm Transfer")])])]), _vm._v(" "), _vm._l((group.business_bank_details), function(bank) {
      return _c('div', [_vm._v("\r\n                                                            " + _vm._s(bank) + "\r\n                                                        ")])
    }), _vm._v(" "), _c('div')], 2)]) : _vm._e(), _vm._v(" "), (group.collections_business && (group.collections_business > 0)) ? _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 2, 0)
        }
      }
    }, [_vm._v("Pay with Your Collections "), _c('br'), _vm._v("-"), _c('b', [_c('i', [_vm._v("You have ")]), _vm._v("NGN: " + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]) : _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      attrs: {
        "disabled": "true"
      }
    }, [_vm._v("Pay with Your Collections:"), _c('br'), _vm._v(" "), _c('b', [_c('i', [_vm._v("- You have ")]), _vm._v("NGN:" + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 1, 0)
        }
      }
    }, [_vm._v("Automatic Bank transfer and"), _c('br'), _vm._v(" Debit Card Payments")])])])])])])]) : _c('div', {
      staticClass: "c-cart-totals",
      staticStyle: {
        "border": "solid 1px#ffa800",
        "text-align": "center"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ffa800",
        "padding-top": "5px"
      }
    }, [_vm._v("Order Placed")])])], 2)
  }), _vm._v(" "), (_vm.processed_single_order_count > 0) ? _c('div', {
    staticClass: "mobile-fix-nav"
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-cart-totals",
    staticStyle: {
      "margin-bottom": "5em",
      "display": "none"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pull-right order-sec",
    staticStyle: {
      "margin-bottom": "7em",
      "margin-right": "1em"
    }
  }, [_c('div', [(_vm.checkout_orders) ? _c('span', [_c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Total Orders: ₦" + _vm._s(_vm.total_order_items_total.toFixed(2)))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Shipping Fee:  ₦" + _vm._s(_vm.total_shipping_fee.toFixed(2)))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Processing Fee:  ₦" + _vm._s(_vm.total_processing_fee.toFixed(2)))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Total: ₦" + _vm._s(_vm.total_orders_amount.toFixed(2)))])]) : _c('span', [_vm._m(8)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.processPayment
    }
  }, [_vm._v("Make Payment")])])])], 2)])]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(9), _vm._v(" "), _c('component-footer')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Coupon Discount Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Order Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Shipping Fee:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('b', [_vm._v("General Shipping Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('b', [_vm._v("Select/Change State:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('b', [_vm._v("Location:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("Gift/Send this Product to a different location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("View Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" {{}}")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-top": "2em"
    }
  }, [_vm._v("No Orders for Checkout")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn default",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Shop Here")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aaf60aa"}!./src/pages/Orderpoint/Checkout/template.html
// module id = 375
// module chunks = 0